import AppErrorPage from '@/components/AppErrorPage'

export default function BasSignupUnavailablePage() {
  return (
    <AppErrorPage
      eyebrow="BAS signup"
      title="BAS signup is no longer available"
      description="The BAS feature and BAS client signup are currently unavailable. Please use another signup option or contact support if you need help."
      primaryAction={{ label: 'Go to homepage', to: '/' }}
    />
  )
}
